<template>
  <div class="card shadow-sm" role="button" @click="selectJobPost(jobPost)">
    <div class="card-body">
      <div class="d-flex text-secondary">
        <div class="flex-fill">Job #{{ jobPost.code }}</div>
        <div class="flex-fill text-right">
          <span v-if="_.size(jobPost.job_post_notification_log) > 0">
            {{ _.head(jobPost.job_post_notification_log).created_at | prettyDate }}
          </span>
          <span v-else>
            {{ jobPost.post_date | prettyDate }}
          </span>
        </div>
      </div>
      <div class="job-post-title py-3">{{ jobPost.title }}</div>
      <div>
        <i class="fas fa-map-marker-alt -status-alert"></i>
        {{ jobPost.address_province | multiLangName }} <span v-if="jobPost.distric"> - </span> {{ jobPost.district | multiLangName }}
      </div>
      <div class="-status-alert mt-2">
        <i class="fab fa-bitcoin"></i>
        <b>{{ jobPost.min_salary | currency }} - {{ jobPost.max_salary | currency }} / {{ salaryType(jobPost.salary_type) }}</b>
      </div>
      <div v-if="jobUser && (jobPost.job_users.length > 0 || isInterestedJob(jobPost))">
        <hr>
        <div class="d-flex">
          <div class="flex-fill">
                    <span v-if="jobPost.job_users.length > 0">
                      มี {{ jobPost.job_users.length }} คนสนใจ
                    </span>
          </div>
          <div class="flex-fill text-right -status-accepted">
                    <span v-if="isInterestedJob(jobPost)">
                      <i class="fas fa-check-circle"></i> คุณสนใจงานนี้
                    </span>
          </div>
        </div>
      </div>

      <div class="row no-gutters mt-4">
        <div class="col-md-12">
          <button class="btn btn-block btn-info">ดูรายละเอียด</button>
        </div>
      </div>
    </div>
  </div><!-- /.end card -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    jobPost: Object
  },
  computed: {
    ...mapState('jobUser', ['jobUser'])
  },
  methods: {
    selectJobPost (jobPost) {
      this.$emit('onSelected', jobPost.id)
    },
    isInterestedJob (jobPost) {
      let result = false
      const jobUsers = jobPost.job_users
      if (jobUsers && jobUsers.length > 0) {
        for (let item of jobUsers) {
          if (this.jobUser.id === item.job_user_id) {
            result = true
            break
          }
        }
      }
      return result
    },
    salaryType (type) {
      let text = ''
      if (type === 'day') {
        text = 'วัน'
      } else if (type === 'week') {
        text = 'สัปดาห์'
      } else {
        text = 'เดือน'
      }
      return text
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jobPost/JobPostItem.vue